const projectSelector = require("./projectSelector");

function qrUploadUrl(sessionId) {
    return `${projectSelector.appUrl(false, true)}/upload/${sessionId}`;
}

module.exports = { qrUploadUrl };
